module.exports = __webpack_public_path__ + "iPhone-11ccf622.png";